import React from "react"
import styled from "styled-components"

import { Color, LineHeight } from "~/consts/style-mixins"

export type Props = {
  percentage: number
  labelSize?: number
  unitSize?: number
}

const ProgressCircle: React.FC<Props> = ({ percentage = 0, labelSize = 35, unitSize = 14 }) => (
  <Wrapper>
    <Stepper className="progress-circle-stepper" percentage={percentage}>
      <Percentage className="progress-circle-percentage">
        <Label className="progress-circle-label" labelSize={labelSize}>
          {percentage}
        </Label>
        <Unit className="progress-circle-unit" unitSize={unitSize}>
          %
        </Unit>
      </Percentage>
    </Stepper>
  </Wrapper>
)

export default React.memo(ProgressCircle)

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`

const Stepper = styled.div<{ percentage: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  height: 100%;
  background-image: ${({ percentage }) =>
    `radial-gradient(${Color.White} 60%, transparent 61%), conic-gradient(${Color.Primary} 0% ${percentage}%, ${Color.BorderGray} ${percentage}% 100%)`};
  border-radius: 50%;
`

const Percentage = styled.div`
  display: flex;
  align-items: baseline;
  color: ${Color.Primary};
`

const Label = styled.span<{ labelSize: number }>`
  font-size: ${({ labelSize }) => `${labelSize}px`};
  font-weight: bold;
  line-height: ${LineHeight._2XS}%;
`

const Unit = styled.span<{ unitSize: number }>`
  font-size: ${({ unitSize }) => `${unitSize}px`};
  font-weight: bold;
  line-height: ${LineHeight._2XS}%;
`
